import React from 'react';
import { useNavigate } from "react-router-dom";
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import {
  Typography,
  Box,
  CardMedia, // Import CardMedia
} from '@mui/material';
import Button, { ButtonProps } from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

// Define styles using makeStyles
const useStyles = makeStyles({
  card: {
    marginBottom: 16,
    backgroundColor: '#f9f9f9',
    maxWidth: '500px',
  },
  welcomeMessage: {
    marginBottom: 16,
    textAlign: 'center',
  },
  button: {
    marginTop: '20px',
    padding: '10px 20px',
    textAlign: 'center',
  },
  item: {
    '&:hover': {
      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',
    },
    transition: 'box-shadow 0.2s ease !important',
    borderRadius: '5px',
  },
  media: {
    height: 140, // Control the height of the image
    borderRadius: '5px', // Rounded corners
  },
  description: {
    color: '#333',
    textAlign: 'left',
  },
});

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark, // Optional: darker hover effect
  },
}));


const Home: React.FC = () => {
  const navigate = useNavigate();
  const classes = useStyles();

  return (
    <>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'center',
          px: 2,
          //maxWidth: '1700px',
          padding: '1em',
          margin: '1em',
        }}
      >
        {[
          {
            title: 'Interactive Guides',
            description: 'Enhance your professional development with our interactive how-to guides. Explore student, pastoral, and teaching themes at your own pace, track your progress 24/7, and develop your skills on your schedule.',
            image: '/pexels-gabby-k-9480123.jpg',
            link: '/guides/staff',
          },
          {
            title: 'Interactive CPD Interview Videos',
            description: 'Access engaging CPD interview videos featuring experts sharing practical tips and insights to enhance your personal and professional skills. Track your progress 24/7 and develop your knowledge on your schedule.',
            image: 'WhatsApp Image 2024-11-13 at 11.14.20 AM.jpeg',
            link: '/videos/staff',
          },
          {
            title: 'Professional Digital Portfolio',
            description: 'Maintain a detailed professional learning log with notes, reflections, and action points. Organise your learning from guides and videos using interactive CPD journals, track your progress 24/7, and develop your skills on your schedule.',
            image: '/pexels-cottonbro-5989926.jpg',
            link: '/additional-development',
          },
        ].map((section, index) => (
          <Box
            key={index}
            sx={{
              flex: '1 1 auto',
              width: {
                xs: '100%', // Stack on extra-small screens
                sm: '100%', // Stack on small screens
                md: '100%',  // 2 cards side by side on medium screens
                lg: '30%',  // 3 cards side by side on large screens and up
              },
              maxWidth: '80%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              backgroundColor: '#fff',
              borderRadius: 1,
              boxShadow: 3,
              overflow: 'hidden',
            }}
          >
            <CardMedia
              component="img"
              image={section.image}
              alt={section.title}
              sx={{ height: 180 }}
            />
            <Box sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>{section.title}</Typography>
              <Typography variant="body2" className={classes.description}>{section.description}</Typography>
              <Box display="flex" justifyContent="center" mt={2}>
                <ColorButton
                  endIcon={<NavigateNextIcon />}
                  variant="contained"
                  onClick={() => navigate(section.link)}
                >
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>Explore</Typography>
                </ColorButton>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>


    </>
  );
};

export default Home;
